   document.addEventListener('DOMContentLoaded', function() {

const flashSales = document.querySelectorAll('.flash_sale');

    flashSales.forEach(flashSaleDiv => {
      const startTime = new Date(flashSaleDiv.getAttribute('data-start'));
      const endTime = new Date(flashSaleDiv.getAttribute('data-end'));
  
      const updateTimer = () => {
          const currentTime = new Date();
          const timeToStart = startTime - currentTime;
          const timeToEnd = endTime - currentTime;
          const timeSinceEnd = currentTime - endTime;
  
          if (timeToStart > 0) {
              // Countdown before flash sale starts
              const totalHours = Math.floor(timeToStart / (1000 * 60 * 60));
              const minutes = Math.floor((timeToStart % (1000 * 60 * 60)) / (1000 * 60));
              const seconds = Math.floor((timeToStart % (1000 * 60)) / 1000);
  
              flashSaleDiv.innerHTML = `<span>Starts in:</span><span> ${totalHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}</span>`;
          } else if (timeToEnd > 0) {
              // Countdown during flash sale
              const totalHours = Math.floor(timeToEnd / (1000 * 60 * 60));
              const minutes = Math.floor((timeToEnd % (1000 * 60 * 60)) / (1000 * 60));
              const seconds = Math.floor((timeToEnd % (1000 * 60)) / 1000);
  
              flashSaleDiv.innerHTML = `<span>Ends in:</span><span> ${totalHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}</span>`;
          } else if (timeSinceEnd <= 60 * 60 * 1000) {
              // Flash sale ended less than an hour ago
              flashSaleDiv.innerHTML = '<span>The flash sale has ended.</span>';
          } else {
              // Flash sale ended more than an hour ago, hide the element
              flashSaleDiv.style.display = 'none';
          }
      };
  
      // Call updateTimer immediately and then every second
      updateTimer(); 
      setInterval(updateTimer, 1000);
  });




     
      });



// smooth scroll

document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector('.header__links.header__links-primary'); // Select the navigation menu

  if (nav) {
    nav.querySelectorAll('a[href^="https://beautyreserve.id/#"]').forEach(anchor => {
      anchor.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default anchor behavior

        console.log("Anchor clicked:", this.getAttribute("href")); // Debugging log

        const targetId = this.getAttribute("href").split("#")[1]; // Extract the ID after #
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          console.log("Target found:", targetId); // Debugging log
          
          const offset =  -200; 
          const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY + offset;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
          });

          // Update the URL hash without jumping
          history.pushState(null, null, `#${targetId}`);
        } else {
          console.log("Target NOT found:", targetId); // Debugging log
        }
      });
    });
  }
});


